import {
  MERCHANT_DATA_FAILD,
  MERCHANT_DATA_LOADING,
  MERCHANT_DATA_REMOVE,
  MERCHANT_DATA_SUCCESS,
} from "../types";

const initialState = {
  merchantData: null,
  loading: false,
  error: null,
  merch_id: null,
};

export const merchantReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: { merchantId: any }; error: any }
) => {
  switch (action.type) {
    case MERCHANT_DATA_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        merchantData: action.payload,
        merch_id: action.payload.merchantId,
      };
    case MERCHANT_DATA_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
        merch_id: null,
      };
    case MERCHANT_DATA_REMOVE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
